import React, { useEffect } from 'react';

export default function Index(_) {

    useEffect(() => {
        
    }, []);

    return (
        <div>home page</div>
    );
}